var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4a2 2 0 012-2h4a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4zM14 4a2 2 0 012-2h4a2 2 0 012 2v16a2 2 0 01-2 2h-4a2 2 0 01-2-2V4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGc+CjxwYXRoIGQ9Ik0yIDRDMiAyLjg5NTQzIDIuODk1NDMgMiA0IDJIOEM5LjEwNDU3IDIgMTAgMi44OTU0MyAxMCA0VjIwQzEwIDIxLjEwNDYgOS4xMDQ1NyAyMiA4IDIySDRDMi44OTU0MyAyMiAyIDIxLjEwNDYgMiAyMFY0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xNCA0QzE0IDIuODk1NDMgMTQuODk1NCAyIDE2IDJIMjBDMjEuMTA0NiAyIDIyIDIuODk1NDMgMjIgNFYyMEMyMiAyMS4xMDQ2IDIxLjEwNDYgMjIgMjAgMjJIMTZDMTQuODk1NCAyMiAxNCAyMS4xMDQ2IDE0IDIwVjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };